import {gql} from '@apollo/client';

export default gql`
  mutation backdateRange($input: BackdateRangeInput!) {
    authed {
      success
    }
    backdateRange(input: $input) {
      success
    }
  }
`;
